"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isFunction = exports.default = isFunction;
function isFunction(object) {
  return typeof object === 'function';
}